module.exports = __webpack_public_path__ + "static/media/P2-thumb-wheel.025ce4bb.svg";